import React, { useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import FormInput from "../../../utils/FormInput";
import "./style/finalizeNoLoginStyle.css";
import InvoiceButtons from "./InvoiceButtons";
import { FormElementModel } from "../../models/FormElementModel";
import { invoiceForm, userPayForm } from "./inputsForm/InputPayFormModels";
import CheckBoxInput from "../../../utils/CheckBoxInput";
import { userPayCheckboxForm } from "./inputsForm/CheckboxPayFormModel";

export type InputsFinalize = {
  firstName: string;
  lastName: string;
  email: string;
  repeatEmail: string;
  phone: string;
  city: string;
  street: string;
  houseNumber: string;
  flatNumber: string;
  zipCode: string;
  NIP: string;
  companyName: string;
  createUser: boolean;
  createInvoice: boolean;

  acceptEAktywni: boolean;
  acceptPrivacyPolicy: boolean;
  acceptStatute: boolean;
};

interface IProps {
  paymentUrl: string;
  onPayTransaction: (value: InputsFinalize) => void;
}

const FinalizeNoLogin: React.FC<IProps> = ({ onPayTransaction, paymentUrl }: IProps) => {
  const [invoiceType, setInvoiceType] = useState<"noInvoice" | "customerInvoice" | "companyInvoice">("noInvoice");
  const {
    register,
    watch,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<InputsFinalize>({});

  const handleRegistration: SubmitHandler<InputsFinalize> = async (data) => {
    onPayTransaction({ ...data, createInvoice: invoiceType !== "noInvoice" });
  };

  return (
    <div className={"finalize-pay-wrapper"}>
      <h3>Dane kontaktowe</h3>
      <form onSubmit={handleSubmit(handleRegistration)}>
        {userPayForm(watch, register).map((item: FormElementModel, index: number) => (
          <FormInput key={index} {...item} errors={errors} />
        ))}

        <InvoiceButtons invoiceType={invoiceType} setInvoiceType={setInvoiceType} />

        {invoiceType !== "noInvoice" && (
          <div className={"inputs-customer-invoice"}>
            {invoiceForm(register, invoiceType === "companyInvoice").map(
              (item: FormElementModel, index: number) =>
                item.name && <FormInput key={index} {...item} errors={errors} />
            )}
          </div>
        )}

        {/* <Controller
          name={"createUser"}
          control={control}
          rules={{ required: false }}
          render={({ field }) => (
            <CheckBoxInput
              name={"createUser"}
              field={field}
              title={<span>Utwórz konto</span>}
              description={
                <React.Fragment>
                  Tak, chcę założyć konto, aby mieć dostęp do swoich biletów i zarządzać moimi rezerwacjami.
                </React.Fragment>
              }
              errors={errors}
            />
          )}
        /> */}
        <div className={"divider"} />

        {userPayCheckboxForm(errors, control).map((item, index) => (
          <React.Fragment key={index}>{item}</React.Fragment>
        ))}

        {paymentUrl === "" ? (
          <input className={"login-button"} type={"submit"} value={"Kupuję i płacę"} />
        ) : (
          <a href={paymentUrl}
          target="blank"
          className="login-button">
            {" "}
            Przejdź do płatności
          </a>
        )}
      </form>
    </div>
  );
};

export default FinalizeNoLogin;
